import { Currency, DeliveryStatus, Locale } from '@synergy/models';

import { ShoppingCartItem, ShoppingCartItemStatus } from '../shopping-cart';
import { ShoppingCartItemDto } from '../dto/shopping-cart-dto';
import { mapShoppingCartArticle } from './shopping-cart-article-mapper';

export const mapShoppingCartItem = (
    item: ShoppingCartItemDto,
    locales: Locale[],
    currency: Currency
): ShoppingCartItem | null => {
    const article = mapShoppingCartArticle(locales, currency, item.product);
    if (article === null) {
        return null;
    }

    let status = ShoppingCartItemStatus.Available;
    if (item.product.deliveryStatus === DeliveryStatus.OnRequest) {
        status = ShoppingCartItemStatus.PriceByRequest;
    } else if (!item.isAvailableForPurchase) {
        status = ShoppingCartItemStatus.Removed;
    } else if (item.hasChanged) {
        status = ShoppingCartItemStatus.Changed;
    }

    return {
        id: item.id,
        netPrice: item.netPrice,
        previewImage: item.previewImage,
        quantity: item.quantity,
        product: article,
        status,
    };
};
